<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>核销列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="平台订单号" clearable v-model="queryInfo.platformOrderNo" @clear="getList()" style="width: 200px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-input placeholder="核销券码" clearable v-model="queryInfo.couponCode" @clear="getList()" style="width: 200px; margin-left: 10px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-input placeholder="核销人员" clearable v-model="queryInfo.verificationBy" @clear="getList()" style="width: 200px; margin-left: 10px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.status" clearable placeholder="核销状态" @change="getList()" style="margin-left: 10px; width: 130px">
                        <el-option label="已核销" :value="1"></el-option>
                        <el-option label="已退单" :value="2"></el-option>
                        <el-option label="核销失败" :value="3"></el-option>
                        <el-option label="退单失败" :value="4"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.isRefunded" clearable placeholder="是否退款" @change="getList()" style="margin-left: 10px; width: 120px">
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                    </el-select>
                    <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="核销开始"
                        end-placeholder="核销结束"
                        value-format="yyyy-MM-dd"
                        @change="onDateChange"
                        style="margin-left: 10px"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <br>
            <el-table :data="list" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="平台" prop="platformName" width="80"></el-table-column>
                <el-table-column label="平台订单号" prop="platformOrderNo" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="核销券码" prop="couponCode" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column label="会员卡名称" prop="productName" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="原价" prop="originalPrice" width="90"></el-table-column>
                <el-table-column label="顾客实付" prop="customerPaid" width="100"></el-table-column>
                <el-table-column label="核销时间" prop="verificationTime" width="175"></el-table-column>
                <el-table-column label="核销人" prop="verificationBy" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success">{{ scope.row.statusName }}</el-tag>
                        <el-tag v-else-if="scope.row.status == 2" type="warning">{{ scope.row.statusName }}</el-tag>
                        <el-tag v-else-if="scope.row.status == 3 || scope.row.status == 4" type="danger">{{ scope.row.statusName }}</el-tag>
                        <el-tag v-else type="info">{{ scope.row.statusName || '未知' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="失败原因" prop="failReason" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="备注" prop="remark" width="150" show-overflow-tooltip></el-table-column>
            </el-table>
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum" :page-sizes="[20, 50, 100]" :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            queryInfo: {
                platform: '',
                platformOrderNo: '',
                couponCode: '',
                productName: '',
                status: '',
                isRefunded: '',
                startDate: '',
                endDate: '',
              verificationBy: '',
                pageNum: 1,
                pageSize: 20
            },
            dateRange: [],
            total: 0,
            list: []
        }
    },
    created() {
        this.getList()
    },
    methods: {
        onDateChange(val) {
            if (val && val.length === 2) {
                this.queryInfo.startDate = val[0]
                this.queryInfo.endDate = val[1]
            } else {
                this.queryInfo.startDate = ''
                this.queryInfo.endDate = ''
            }
            this.getList()
        },
        async getList() {
            const { data: res } = await this.$http.get('verificationrecordlist', { params: this.queryInfo })
            if (res.code === 0 || res.status === 0) {
                this.total = res.totalSize || 0
                this.list = res.data || []
            }
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize
            this.getList()
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage
            this.getList()
        }
    }
}
</script>
